import { c as _c } from "react/compiler-runtime";
interface OrthopedicSurgeryIconProps {
  size?: number;
  className?: string;
}
const OrthopedicSurgeryIcon = t0 => {
  const $ = _c(9);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M13.094 15.4796C12.226 14.1776 12.0089 16.0215 10.9239 16.5643C10.3816 16.5645 9.73047 15.6963 9.29649 16.5643C8.75407 17.6491 9.29627 18.1913 9.83869 18.7337L9.83888 18.7339C10.2729 19.1679 11.2857 18.5534 11.4665 18.1917C12.7685 17.7577 14.1789 19.4575 14.7214 20.3616H19.0613C19.6038 20.3616 19.0613 18.7342 19.0613 18.1917C19.0613 17.6492 20.6887 17.6492 19.6038 16.5643C18.5188 15.4793 15.8064 16.5645 15.2639 16.5645C14.7214 16.5645 14.1789 17.107 13.094 15.4796Z" stroke="currentColor" strokeWidth="1.08496" strokeLinejoin="round" />;
    t7 = <path d="M12.009 19.819C11.5751 19.385 10.7433 20.3614 10.3816 20.9039C8.75409 20.904 8.75416 19.819 8.21168 20.3614C7.66919 20.9038 8.75416 23.0738 9.83912 23.0738C10.9241 23.0738 10.3816 22.5313 12.009 23.0738C13.311 23.5078 13.2748 24.7012 13.094 25.2437C14.9023 25.4245 18.5188 25.6777 18.5188 25.2437V23.6163C19.3868 22.7483 19.6038 22.1696 19.6038 21.9888H14.179C13.6365 21.9888 12.5515 20.3614 12.009 19.819Z" stroke="currentColor" strokeWidth="1.08496" strokeLinejoin="round" />;
    t8 = <path d="M8.21175 7.88409C7.77776 6.58214 9.47754 6.97996 10.3817 7.34161C10.3817 6.79897 10.3817 5.71433 10.9242 5.17176C11.3582 4.73771 12.19 5.35262 12.5516 5.71433C12.9133 6.07595 13.7451 6.47372 14.179 5.17176C14.7215 3.54432 15.264 4.0868 16.8915 4.0868C18.5189 4.0868 17.4339 6.7992 18.5189 7.88417C19.6039 8.96913 17.9764 9.51161 15.8065 10.0541C13.6366 10.5966 13.6366 9.51161 13.0941 8.96913C12.5516 8.42665 11.4667 8.96913 10.3817 9.51161L10.3817 9.51161C9.29671 10.0541 8.75423 9.51154 8.21175 7.88409Z" stroke="currentColor" strokeWidth="1.08496" strokeLinejoin="round" />;
    t9 = <path d="M12.0088 10.5965C11.1408 10.1625 10.5622 10.7774 10.3814 11.139C9.83887 11.139 8.75391 11.1391 8.75391 12.2241C8.75391 13.3091 9.29639 13.8515 10.3814 14.394C11.4663 14.9365 10.9238 13.3091 12.5513 13.3091C13.8532 13.3091 14.5404 14.394 14.7212 14.9365C18.1931 14.9365 19.0611 14.5749 19.0611 14.394C19.0611 13.8515 19.6035 10.5965 19.0611 10.5967C18.5186 10.5968 15.8062 11.6816 14.1787 11.6816C12.5513 11.6816 13.0938 11.139 12.0088 10.5965Z" stroke="currentColor" strokeWidth="1.08496" strokeLinejoin="round" />;
    $[2] = t6;
    $[3] = t7;
    $[4] = t8;
    $[5] = t9;
  } else {
    t6 = $[2];
    t7 = $[3];
    t8 = $[4];
    t9 = $[5];
  }
  let t10;
  if ($[6] !== t3 || $[7] !== t5) {
    t10 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}{t8}{t9}</svg>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  return t10;
};
export default OrthopedicSurgeryIcon;